import React from 'react';
import SelectionListItem from '../../../../SelectionList/SelectionListItem';
import BasicUserAvatar from '../../../../User/_partials/BasicUserAvatar';
import ArrowRight from '../../../../Icons/ArrowRight';
var GroupListItem = function (_a) {
    var group = _a.group;
    return (React.createElement(SelectionListItem, { label: group.username, prefix: React.createElement(BasicUserAvatar, { user: group, size: 35 }), fillContainerWidth: true, suffixIcon: ArrowRight, showSuffixOnlyOnHover: true }));
};
GroupListItem.displayName = 'GroupListItem';
export default GroupListItem;
//# sourceMappingURL=GroupListItem.js.map